const semanticClassNames = {
  root: 'dropdown-menu',
  menuItem: 'dropdown-menu__item',
  subMenu: 'dropdown-menu__submenu',
} as const;

export default semanticClassNames;
